import gql from 'graphql-tag';

export default gql`
query ($params: ListQueryArgs!) {
    fakturaAssist{
    	listFA_TextModule(params: $params){
    		id
    		name
 		}
 	}
}`;
